// @ components
import { RAInvestmentExperienceStep } from './RAInvestmentExperienceStep';
// @ vendors
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// @ actions
import RASuitabilityTestWizardActions from 'actions/RASuitabilityTestWizardActions';
import { actions as formActions } from 'react-redux-form';
import RASuitabilityTest from 'actions/RASuitabilityTest';
import modalCancelActions from 'actions/modalCancelActions';

export const RAInvestmentExperienceStepContainer = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        raTestActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    })
)(RAInvestmentExperienceStep);
